import { extensionUninstallParamsType } from 'types';
import axiosClient from './axiosClient';
import { endpoints } from './endpoints';

export const extensionUninstallFeedback = async (params: extensionUninstallParamsType) => {
  const resp = await axiosClient.post(endpoints.feedbackUninstallExtension, params);
  return resp.data;
};
